import React from 'react';
import { usePageContext } from 'Context/PageContext';
import { useTracking } from 'Tracking/tracking-api/useTracking';
import { Button } from 'Components/frameworks/button/Button';
import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer';
type Props = {
  buttonLabel: string;
  buttonLink: string;
  title: string;
};
export const ButtonTicketLine = ({ buttonLabel, buttonLink, title }: Props) => {
  const { pageType } = usePageContext();
  const track = useTracking({
    actionGA: 'priceBar',
    categoryGA: pageType,
    labelGA: 'getAQuote',
  });
  return (
    <SiteContainer className="Line Line-ButtonTicket">
      <div className="mt-30 flex flex-col gap-10 rounded-12 border-1 border-lightGrey bg-white p-10 shadow-diffuse md:mt-0 md:flex-row md:items-center">
        <p className="flex-1 px-10 font-sans text-14 font-bold text-black">{title}</p>
        <Button data-testid="getButtonTicketLineBtn" onClick={() => track()} url={buttonLink}>
          {buttonLabel}
        </Button>
      </div>
    </SiteContainer>
  );
};
